"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileForgotPasswordForm = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

var _commonElements = require("../commonElements");

var _QuickInput = _interopRequireDefault(require("../../QuickInput"));

var _formik = require("formik");

var _react = _interopRequireDefault(require("react"));

var _Validators = require("../Validators");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MobileForgotPasswordForm = function MobileForgotPasswordForm(props) {
  return _react.default.createElement(_formik.Formik, {
    initialValues: props.values,
    onSubmit: props.handleSubmit,
    validationSchema: _Validators.ForgotPasswordValidator
  }, function (_ref) {
    var values = _ref.values,
        errors = _ref.errors,
        touched = _ref.touched,
        handleChange = _ref.handleChange,
        handleBlur = _ref.handleBlur,
        handleSubmit = _ref.handleSubmit,
        isSubmitting = _ref.isSubmitting,
        isValid = _ref.isValid,
        status = _ref.status;
    return _react.default.createElement(_commonElements.MobileContainer, null, _react.default.createElement(_commonElements.MobileInnerWrapper, null, _react.default.createElement(_commonElements.FormContainer, {
      onSubmit: handleSubmit,
      height: 270
    }, _react.default.createElement(_commonElements.MobileHeader, null, "Reset your password"), _react.default.createElement(_QuickInput.default, {
      block: true,
      error: errors.email,
      placeholder: "Enter your email address",
      name: "email",
      label: "Email",
      type: "email",
      value: values.email,
      onChange: handleChange,
      onBlur: handleBlur,
      autoFocus: true
    }), status && !status.success && _react.default.createElement(_commonElements.Error, {
      show: true
    }, status.error), _react.default.createElement(_commonElements.SubmitButton, {
      disabled: isSubmitting
    }, "Send me reset instructions"), _react.default.createElement(_commonElements.Footer, {
      handleTypeChange: props.handleTypeChange,
      mode: "forgot"
    }))));
  });
};

exports.MobileForgotPasswordForm = MobileForgotPasswordForm;
//# sourceMappingURL=ForgotPasswordForm.js.map